module.exports = __webpack_public_path__ + "img/vinculo_acompanhamento.8c90c830.svg";